export default "__VITE_ASSET__pxd5rGxL__"